import React from "react";
import "../Homepage/home.css";
import Productgrid from "../Homepage/Productgrid";
import { Link } from "react-router-dom";
import leftTree from "../../assets/images/left-tree.png";
import righttree from "../../assets/images/right-tree.png";
import { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useParams } from "react-router-dom";
import { apiurl } from "../../Constants";
import axios from "axios";
import { FadeLoader } from "react-spinners";
function ArrayProduct() {
  const [mainClass, setMainClass] = useState("col-3 four-grid");
  const [activeStick, setActiveStick] = useState(""); // To manage the active stick button
  const { array_id } = useParams();

  const [data, setData] = useState([]);
  // const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);

  const productIds = array_id
    .split(",")
    .map((id) => parseInt(id.trim()))
    .filter((id) => !isNaN(id));

  useEffect(() => {
    const fetchDetais = async () => {
      setLoading(true);
      try {
        const response = await axios.post(apiurl + "array_products", {
          product_id: productIds,
        });
        setData(response.data.products)
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    fetchDetais();
  }, [array_id]);

  useEffect(() => {
    AOS.init({
      once: false,
    });

    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Set initial grid class and active stick based on screen size
  useEffect(() => {
    const mediaQuery991 = window.matchMedia("(max-width: 991px)");
    const mediaQuery767 = window.matchMedia("(max-width: 767px)");
    const mediaQuery575 = window.matchMedia("(max-width: 575px)");

    // Function to set the appropriate grid layout and stick button
    const handleScreenChange = () => {
      if (mediaQuery575.matches) {
        // Below 575px: Activate single-grid and the corresponding stick button
        setMainClass("col-6 two-grid");
        setActiveStick("stick_two");
      } else if (mediaQuery767.matches) {
        // Below 767px: Activate two-grid and the corresponding stick button
        setMainClass("col-6 two-grid");
        setActiveStick("stick_two");
      } else if (mediaQuery991.matches) {
        // Below 991px: Activate three-grid and the corresponding stick button
        setMainClass("col-4 three-grid");
        setActiveStick("stick_three");
      } else {
        // Web: Activate four-grid and the corresponding stick button
        setMainClass("col-3 four-grid");
        setActiveStick("stick_four");
      }
    };

    // Initial check and setting up event listeners
    handleScreenChange(); // Check initial state
    mediaQuery575.addEventListener("change", handleScreenChange);
    mediaQuery767.addEventListener("change", handleScreenChange);
    mediaQuery991.addEventListener("change", handleScreenChange);

    // Cleanup event listeners on component unmount
    return () => {
      mediaQuery575.removeEventListener("change", handleScreenChange);
      mediaQuery767.removeEventListener("change", handleScreenChange);
      mediaQuery991.removeEventListener("change", handleScreenChange);
    };
  }, []);

  // Stick button handlers
  function stickhandleone() {
    setMainClass("col-12 single-grid");
    setActiveStick("stick_one");
  }

  function stickhandletwo() {
    setMainClass("col-6 two-grid");
    setActiveStick("stick_two");
  }

  function stickhandlethree() {
    setMainClass("col-4 three-grid");
    setActiveStick("stick_three");
  }

  function stickhandlefour() {
    setMainClass("col-3 four-grid");
    setActiveStick("stick_four");
  }

  function stickhandlesix() {
    setMainClass("col-2 six-grid");
    setActiveStick("stick_six");
  }

  return (
    <>
      {loading ? (
        <div className="row">
          <div
            className="col-12"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <FadeLoader />
          </div>
        </div>
      ) : (
        <section className="wishlist_section col_divide_design pt-40 pb-40">
          <div className="container">
            <div className="row first_row">
              <div className="col-xl-3 col-lg-3 main-stick-inner">
                <div className="main-stick">
                  <div
                    onClick={stickhandleone}
                    className={`${
                      activeStick === "stick_one"
                        ? "active-bg-grid"
                        : "sticks-inner-box"
                    } stick_one`}
                  >
                    <button
                      className={
                        activeStick === "stick_one"
                          ? "stickhandleone-one"
                          : "stick-color"
                      }
                    ></button>
                  </div>
                  <div
                    onClick={stickhandletwo}
                    className={`${
                      activeStick === "stick_two"
                        ? "active-bg-grid"
                        : "sticks-inner-box"
                    } stick_two`}
                  >
                    <button
                      className={
                        activeStick === "stick_two"
                          ? "stickhandleone-two"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_two"
                          ? "stickhandleone-two"
                          : "stick-color"
                      }
                    ></button>
                  </div>
                  <div
                    onClick={stickhandlethree}
                    className={`${
                      activeStick === "stick_three"
                        ? "active-bg-grid"
                        : "sticks-inner-box"
                    } stick_three`}
                  >
                    <button
                      className={
                        activeStick === "stick_three"
                          ? "stickhandleone-three"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_three"
                          ? "stickhandleone-three"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_three"
                          ? "stickhandleone-three"
                          : "stick-color"
                      }
                    ></button>
                  </div>
                  <div
                    onClick={stickhandlefour}
                    className={`${
                      activeStick === "stick_four"
                        ? "active-bg-grid"
                        : "sticks-inner-box"
                    } stick_four`}
                  >
                    <button
                      className={
                        activeStick === "stick_four"
                          ? "stickhandleone-four"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_four"
                          ? "stickhandleone-four"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_four"
                          ? "stickhandleone-four"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_four"
                          ? "stickhandleone-four"
                          : "stick-color"
                      }
                    ></button>
                  </div>
                  <div
                    onClick={stickhandlesix}
                    className={`${
                      activeStick === "stick_six"
                        ? "active-bg-grid"
                        : "sticks-inner-box"
                    } stick_five`}
                  >
                    <button
                      className={
                        activeStick === "stick_six"
                          ? "stickhandleone-five"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_six"
                          ? "stickhandleone-five"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_six"
                          ? "stickhandleone-five"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_six"
                          ? "stickhandleone-five"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_six"
                          ? "stickhandleone-five"
                          : "stick-color"
                      }
                    ></button>
                    <button
                      className={
                        activeStick === "stick_six"
                          ? "stickhandleone-five"
                          : "stick-color"
                      }
                    ></button>
                  </div>
                </div>
              </div>
              {/* <div className="col-xl-6 col-lg-6 main-heading-inner-box">
                <div className="inner-box">
                  <img
                    src={leftTree}
                    alt="img"
                    className="heading-left-image"
                  />
                  <h3 className="main-heading-1">{title}</h3>
                  <img
                    src={righttree}
                    alt="img"
                    className="heading-right-image"
                  />
                </div>
              </div> */}
            </div>
            <div className="row second_row">
              {data !== undefined && data.length > 0
                ? data.map((item, index) => (
                    <div
                      className={`${mainClass} product_grid_col`}
                      key={index}
                    >
                      <Productgrid
                        items={item}
                        productdetailslink={`/product-details/${item.slug}`}
                      />
                    </div>
                  ))
                : null}
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default ArrayProduct;
